<div class="row">
  <div class="col-12">
    <div class="accordion" id="historyAccordion">
      <div class="accordion-item shadow-sm border-0">
        <h2 class="accordion-header" id="headingHistory">
          <button
            class="accordion-button bg-white text-dark fw-bold"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseHistory"
            aria-expanded="false"
            aria-controls="collapseHistory"
          >
            {{ 'PEOPLE.DETAILS.SHOW_HISTORY' | translate }}
          </button>
        </h2>
        <div id="collapseHistory" class="accordion-collapse collapse" aria-labelledby="headingHistory" data-bs-parent="#historyAccordion" (show.bs.collapse)="fetchEvents()">
          <div class="accordion-body">
            @if (isLoading) {
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
            </div>
            } @else {
                @if (events && events.length > 0) {
                <ul class="list-unstyled">
                  @for (event of events; track event) {
                  <li class="card mb-3 p-3 event-card">
                    <div class="d-flex align-items-start">
                        <div class="event-icon-container me-3">
                        <i [class]="getIconForEvent(event.typeId)" [style.color]="getIconColorForEvent(event.typeId)"></i>
                        </div>
                        <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            <h6 class="mb-0 fw-bold">{{ 'EVENTS.TYPES.' + event.typeId.toUpperCase() | translate }}</h6>
                            <div>
                              <div><small class="text-muted">{{ event.date | date: 'dd MMM yyyy HH:mm' }}</small></div>
                              <div>
                                <small class="text-muted">{{ 'EVENTS.BY' | translate }} 
                                  @if (event.author.firstName && event.author.lastName) {
                                  {{ event.author.firstName + ' ' + event.author.lastName }}
                                  } @else {
                                  {{ 'EVENTS.UNKNOWN_AUTHOR' | translate }}
                                  }
                                </small>
                              </div>
                            </div>
                        </div>
                        <div class="mt-2">
                          <ul class="list-unstyled m-0">
                          @for (detail of event.details; track detail) {
                            <li>
                              {{ detail.key | translate:detail.params }}
                            </li>
                          }
                          </ul>
                        </div>
                        <a href="#" class="btn btn-link p-0 mt-2 small" (click)="toggleRawDetails($event, event.id)" >
                            @if (showRawDetailsMap[event.id]) {
                            {{ 'EVENTS.HIDE_RAW_DETAILS' | translate }}
                            } @else {
                            {{ 'EVENTS.VIEW_RAW_DETAILS' | translate }}
                            }
                        </a>
                        @if (showRawDetailsMap[event.id]) {
<div class="mt-2 p-2 bg-light border rounded">
                            <pre class="m-0">{{ getRawDetails(event) }}</pre>
                        </div>
}
                        </div>
                    </div>
                    </li>
}
                </ul>
                } @else {
                <p class="text-muted">{{ 'EVENTS.NO_HISTORY' | translate }}</p>
                }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>